import { connect } from 'react-redux';
import { negate } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';
import { getDeparturesStatistics, isLoaded } from '../selectors/serviceStatistics';
import { navigateToCheckoutReport, navigateToReservationOverviewDepartures } from '../actions/serviceStatistics';
import ConnectedPieChart from '../../charts/PieChart/ConnectedPieChart';
import { trackDashboardPieClick } from '../actions/util';

export default connect(
    createStructuredSelector({
        data: getDeparturesStatistics,
        showLoader: negate(isLoaded),
    }),
    // @ts-expect-error $TSFixMeError: Property 'checkoutReportEnabled' does not exist on type '{}'.
    (dispatch, { checkoutReportEnabled }) => ({
        onClick: () => {
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'.
            dispatch(trackDashboardPieClick('DeparturesStatisticsChart'));

            if (checkoutReportEnabled) {
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { resolveRoute }: $TSFixMe) => void' is not assignable to par...
                dispatch(navigateToCheckoutReport());
            } else {
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
                dispatch(navigateToReservationOverviewDepartures());
            }
        },
    })
)(ConnectedPieChart);
